import { FeedbackMessengerWindowDraft } from './draft/feedback-messenger-window-draft.component'
import { FeedbackMessengerWindow } from './feedback-messenger-window.component'
import { FeedbackMessengerTemplateSelect } from './template-select/feedback-messenger-window-template-select.component'
import { FeedbackMessengerWindowWysiwyg } from './wysiwyg/feedback-messenger-window-wysiwyg.component'

export const FeedbackMessenger = (() => {
	const init = () => {
		FeedbackMessengerWindow.init()
		// Draft restore must run before the wysiwyg init: it writes the draft
		// content into the textarea and Jodit reads the textarea at creation.
		FeedbackMessengerWindowDraft.init()
		FeedbackMessengerWindowWysiwyg.init()
		FeedbackMessengerTemplateSelect.init()
	}

	return {
		init,
	}
})()
